import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const TermsPage = () => {
  return (
    <div data-testid="terms-page">
      {/* Hero */}
      <section className="bg-slate-900 text-white py-16 noise-bg">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Terms of Service</h1>
            <p className="text-slate-300">Last updated: December 2025</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="section-light">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto prose prose-slate prose-lg"
          >
            <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-8 md:p-12">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Acceptance of Terms</h2>
              <p className="text-slate-600 mb-6">
                By accessing and using CyberX Calls services, you accept and agree to be bound by the terms 
                and provisions of this agreement. If you do not agree to these terms, please do not use our services.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Description of Services</h2>
              <p className="text-slate-600 mb-6">
                CyberX Calls provides Voice over IP (VoIP) services including but not limited to:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
                <li>VoIP/SIP trunk services</li>
                <li>International voice termination (A-Z routes)</li>
                <li>Hosted PBX solutions</li>
                <li>Call center routing services</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">3. Account Registration</h2>
              <p className="text-slate-600 mb-6">
                To use our services, you must register for an account at cyberxcalls.com/portal. You agree to:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
                <li>Provide accurate and complete registration information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Accept responsibility for all activities under your account</li>
                <li>Notify us immediately of any unauthorized use</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">4. Payment Terms</h2>
              <p className="text-slate-600 mb-6">
                CyberX Calls operates on a prepaid basis:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
                <li>Minimum initial recharge: 100 USD or 100 EUR</li>
                <li>All payments are non-refundable</li>
                <li>Credits never expire as long as the account remains active</li>
                <li>Rates are subject to change with notice</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">5. Acceptable Use Policy</h2>
              <p className="text-slate-600 mb-6">
                You agree not to use our services for:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
                <li>Any illegal or fraudulent activities</li>
                <li>Transmission of spam or unsolicited communications</li>
                <li>Activities that violate telecommunications regulations</li>
                <li>Any purpose that could damage our network or reputation</li>
              </ul>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">6. Service Level</h2>
              <p className="text-slate-600 mb-6">
                While we strive for 99.9% uptime, VoIP services depend on various factors including internet 
                connectivity and carrier availability. We do not guarantee uninterrupted service.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">7. Liability Limitation</h2>
              <p className="text-slate-600 mb-6">
                CyberX Calls shall not be liable for any indirect, incidental, special, or consequential damages 
                arising from the use or inability to use our services. Our total liability is limited to the 
                amount paid by you in the preceding 30 days.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">8. Termination</h2>
              <p className="text-slate-600 mb-6">
                We reserve the right to suspend or terminate your account for violation of these terms. You may 
                close your account at any time. Remaining credits are non-refundable upon termination.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">9. Modifications</h2>
              <p className="text-slate-600 mb-6">
                We may modify these terms at any time. Continued use of our services after changes constitutes 
                acceptance of the modified terms.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">10. Contact Information</h2>
              <p className="text-slate-600 mb-6">
                For questions about these terms, contact us at:
              </p>
              <ul className="list-none text-slate-600 mb-6 space-y-2">
                <li><strong>Email:</strong> admin@cyberxcalls.com</li>
                <li><strong>Phone:</strong> +1 (973) 922-3220</li>
                <li><strong>Telegram:</strong> @cyberx007</li>
              </ul>

              <div className="border-t border-slate-200 pt-6 mt-8">
                <p className="text-slate-500 text-sm">
                  By using CyberX Calls services, you acknowledge that you have read, understood, and agree 
                  to be bound by these Terms of Service.
                </p>
              </div>
            </div>

            <div className="text-center mt-8">
              <Link to="/privacy" className="text-red-600 hover:text-red-700 font-medium">
                View Privacy Policy →
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
